import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useAddBookMutation,
  useEditBookMutation,
  useGetBookQuery,
} from '../features/api/apiSlice';
import handleInput from '../utils/handleInput';

const BookForm = () => {
  const { bookId } = useParams();
  const { data: book } = useGetBookQuery(bookId);
  const [addBook] = useAddBookMutation();
  const [editBook] = useEditBookMutation();


  let initialFormData = {
    name: '',
    author: '',
    thumbnail: '',
    price: 0,
    rating: 0,
    featured: false,
  };

  const [formData, setFormData] = useState(initialFormData);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const inputValue = handleInput(e);

    setFormData((prevFormData) => {
      return {
        ...prevFormData,
        [e.target.name]: inputValue,
      };
    });
  };

  useEffect(() => {
    if (JSON.stringify(book) !== JSON.stringify({})) {
      setFormData(book);
    }
  }, [book]);

  const { name, author, thumbnail, price, rating, featured } = formData || {};

  const handleSubmit = (e) => {
    e.preventDefault();
    if (bookId) {
      editBook({ id: bookId, data: formData });
    } else {
      addBook(formData);
    }
    setFormData({
      name: '',
      author: '',
      thumbnail: '',
      price: 0,
      rating: 0,
      featured: false,
    });

    navigate('/');
  };

  return (
    <main className="py-6 2xl:px-6">
      <div className="container">
        <div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
          <h4 className="mb-8 text-xl font-bold text-center">
            {bookId ? 'Edit Book' : 'Add New Book'}
          </h4>
          <form className="book-form" onSubmit={handleSubmit}>
            <div className="space-y-2">
              <label htmlFor="lws-bookName">Book Name</label>
              <input
                required
                className="text-input"
                type="text"
                id="lws-bookName"
                name="name"
                value={name}
                onChange={handleChange}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="lws-author">Author</label>
              <input
                required
                className="text-input"
                type="text"
                id="lws-author"
                name="author"
                value={author}
                onChange={handleChange}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="lws-thumbnail">Image Url</label>
              <input
                required
                className="text-input"
                type="text"
                id="lws-thumbnail"
                name="thumbnail"
                value={thumbnail}
                onChange={handleChange}
              />
            </div>

            <div className="grid grid-cols-2 gap-8 pb-4">
              <div className="space-y-2">
                <label htmlFor="lws-price">Price</label>
                <input
                  required
                  className="text-input"
                  type="number"
                  id="lws-price"
                  name="price"
                  value={price}
                  onChange={handleChange}
                />
              </div>

              <div className="space-y-2">
                <label htmlFor="lws-rating">Rating</label>
                <input
                  required
                  className="text-input"
                  type="number"
                  id="lws-rating"
                  name="rating"
                  min="1"
                  max="5"
                  value={rating}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="flex items-center">
              <input
                id="lws-featured"
                type="checkbox"
                name="featured"
                className="w-4 h-4"
                checked={featured}
                onChange={handleChange}
              />
              <label htmlFor="lws-featured" className="ml-2 text-sm">
                {' '}
                This is a featured book{' '}
              </label>
            </div>

            <button type="submit" className="submit" id="lws-submit">
              {bookId ? 'Edit Book' : 'Add Book'}
            </button>
          </form>
        </div>
      </div>
    </main>
  );
};

export default BookForm;
